import { render, staticRenderFns } from "./VsPaginationTable.vue?vue&type=template&id=1ff359e3"
import script from "./VsPaginationTable.vue?vue&type=script&lang=js"
export * from "./VsPaginationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports